import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// reactstrap components
import {
  Card,
  CardHeader,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Button,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';
import { getUserAll } from 'services/user';
import { deleteById } from 'services/user';
import { Notification } from 'notification/notification';

const initialStateListUser = [
  {
    id: 0,
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
  },
];

const Users = () => {
  let history = useHistory();
  const [userList, setUserList] = useState(initialStateListUser);

  useEffect(() => {
    async function getData() {
      const data = await getUserAll();
      if (data !== undefined) {
        setUserList(data.filter((us) => !us?.email.includes('@consigned.com')));
      }
    }
    getData();
  }, []);

  const handleEditUser = (e, id) => {
    e.preventDefault();
    history.push('/admin/user/' + id);
  };

  const handleNewUser = (e) => {
    e.preventDefault();
    history.push('/admin/user/new');
  };

  const handleDeleteUser = async (e, index, id) => {
    const status = await deleteById(id);
    if (status === 200) {
      Notification(status, 'Usuário removido com sucesso!');
      let data = userList;
      data.splice(index, 1);
      setUserList([...data]);
      return;
    }
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className='mt--7' fluid>
        {/* Table */}
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <CardHeader className='border-0'>
                <Row className='align-items-center'>
                  <div className='col'>
                    <h3 className='mb-0'>Lista de Usuários</h3>
                  </div>
                  <div className='col text-right'>
                    <Button color='primary' onClick={handleNewUser} size='sm'>
                      Adicionar usuário
                    </Button>
                  </div>
                </Row>
              </CardHeader>
              <Table className='align-items-center table-flush' responsive>
                <thead className='thead-light'>
                  <tr>
                    <th scope='col'>ID</th>
                    <th scope='col'>Nome</th>
                    <th scope='col'>Usuário</th>
                    <th scope='col'>E-mail</th>
                    <th scope='col'>Telefone</th>
                    <th scope='col' />
                  </tr>
                </thead>
                <tbody>
                  {userList.map((value, key) => {
                    return (
                      <>
                        <tr key={key}>
                          <td>{value.id}</td>
                          <td>{value.firstName + ' ' + value.lastName}</td>
                          <td>{value.username}</td>
                          <td>{value.email}</td>
                          <td>{value.phoneNumber}</td>
                          <td className='text-right'>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className='btn-icon-only text-light'
                                role='button'
                                size='sm'
                                color=''
                              >
                                <i className='fas fa-ellipsis-v' />
                              </DropdownToggle>
                              <DropdownMenu
                                className='dropdown-menu-arrow'
                                right
                              >
                                <DropdownItem
                                  onClick={(e) => handleEditUser(e, value.id)}
                                >
                                  Editar
                                </DropdownItem>
                                <DropdownItem
                                  onClick={(e) =>
                                    handleDeleteUser(e, key, value.id)
                                  }
                                >
                                  Excluir
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Users;
